import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useAuthStore } from "@/stores/auth.store.js";

export function useAuth() {
  const authStore = useAuthStore();

  const { user, isLoading, isInitialized, menu } = storeToRefs(authStore);

  const isAuthenticated = computed(() => !!user.value);
  const userName = computed(() => user.value?.name || "");
  const userEmail = computed(() => user.value?.email || "");
  const userId = computed(
    () =>
      user.value?.id ||
      user.value?.user_id ||
      user.value?.username ||
      user.value?.email ||
      null
  );
  const isAdmin = computed(() => {
    const roles = user.value?.roles || [];
    return roles.includes("ADMINISTRADOR");
  });
  const userRoles = computed(() => user.value?.roles || []);
  const canUserReview = computed(() => {
    const roles = userRoles.value || [];
    const userData = user.value || {};

    if (roles.includes("ADMINISTRADOR")) {
      return true;
    }

    if (roles.includes("REVISOR")) {
      return true;
    }

    if (roles.includes("ELABORADOR")) {
      return userData.can_review_own_items === true;
    }

    return false;
  });

  const initializeAuth = () => authStore.initializeAuth();
  const fetchUser = () => authStore.fetchUser();
  const logout = () => authStore.logout();
  const clearSession = () => authStore.clearSession();

  return {
    user,
    isLoading,
    isInitialized,
    menu,
    isAuthenticated,
    userName,
    userEmail,
    userId,
    isAdmin,
    userRoles,
    canUserReview,
    initializeAuth,
    fetchUser,
    logout,
    clearSession,
  };
}
